import React from 'react'
import { Footer } from '../../../common/footer/footer'
import { useState } from 'react';

import bannerBG from "../../../../assets/Instituteppvimages/bannerbg.svg";
import { BannerPpvStrip } from "../../../common/bannerPpvStrip/bannerPpvStrip.jsx";

import { OfferCardListJSX } from '../../../common/offerCardList/offerCardList';
import { useTranslation } from "react-i18next";
import { Pagination } from '../../../common/pagination/uiPagination';

const ListOfOffersJsx = (props) => {


  const { t } = useTranslation();
  const {
    offerData,
    onPaginationButtonClick, page,
    profileData,
  } = props;
  const itemsPerPage = 10
  const [currentPage] = useState(1);
  const currentItems = offerData?.data?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <>
      <section className={["listofoffermainsection"]}>

        <BannerPpvStrip bannerBG={bannerBG} profileData={profileData} />
        <div className="container-fluid">
          <section className="exclusive offerlistpadding">
            <OfferCardListJSX
              SubCatTitle={t("PPVINSTITUTE.OFFERTITLE")}
              SubCatText={t("PPVINSTITUTE.OFFERSUBTITLE")}
              offerData={currentItems}
              isDescription={true}
              isSlider={false}
            />

            {currentItems?.length > 0 && <section className="newpagination">
              <Pagination
                currentPage={currentPage}
                page={page}
                allOffersData={offerData.data}
                currentItems={currentItems}
                onPaginationButtonClick={onPaginationButtonClick}
                itemsPerPage={itemsPerPage}

              />  </section>}

          </section>
        </div>
      </section>
      <Footer />
    </>

  );
};

export default ListOfOffersJsx;